module.exports = __webpack_public_path__ + "media/images/riders/small/MATHIAS_FLUECKIGER-2fc57ede02b08c29728b47275cfd3788.png";